export const DIMENSIONS = [

    { value:  1, label:  "Piccola/Media" },
    { value:  2, label:  "Grande"  }

];
